import React, { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import CreateForm from "components/Form/CreateForm/CreateForm";
import useAPI from "../../../hooks/useAPI";
import { GlobalQueries } from "../../../hooks/useRefreshQuery";
import ProfilePage from "../ProfilePage";
import AuthContext from "../../../store/auth-context";
import scss from "./CompanyProfilePage.module.scss";
import leftForm from "./leftFormFields.json";
import rightForm from "./rightFormFields.json";
import { useTranslation } from "react-i18next";
import { printError } from "../../../helpers/apiError";
import Empty from "components/Empty/Empty";

const CompanyProfilePage = () => {
    const { t } = useTranslation();

    const api = useAPI();
    const apiPath = "/profile/company";
    const authCtx = useContext(AuthContext);
    const { data: companyData } = useQuery([GlobalQueries.Profile.CompanyProfile], () => api.get(`${apiPath}/basic-data`));
    const { data: addressData } = useQuery([GlobalQueries.Profile.CompanyAddress], () => api.get(`${apiPath}/head-office-address`));
    const { data: config } = useQuery(["companyProfileConfig"], () => api.get("/options/profile-page/company-profile/config"));

    const [company, setCompany] = useState();
    const [address, setAddress] = useState();
    const [updateCountryId, setUpdateCountryId] = useState(address?.id_country);

    const [addressFormField, setAddressFormField] = useState(rightForm);
    const [updateFormFields, setUpdateFormFields] = useState(1);

    useEffect(() => {
        setCompany(companyData);
    }, [companyData, setCompany]);

    useEffect(() => {
        setAddress(addressData);
    }, [addressData, setCompany]);
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const handleUser = async () => {
        await api.get("/profile/user-data").then((response) => {
            if (response) {
                authCtx.refreshUser(response);
            }
        });
    };

    const submitHandlerCompany = () => {
        setLoading(true);
        api.post(`${apiPath}/basic-data`, company)
            .then((response) => {
                toast.success(response?.message ? response?.message : t("global-message-successfully_changed"));
                handleUser();
                setLoading(false);
            })
            .catch((error) => {
                toast.error(printError(error) ? printError(error) : t("global-message-unknown_error"));
                setLoading(false);
            });
    };

    const submitHandlerAddress = () => {
        const idTownElement = addressFormField.find((item) => item.field === "id_town");
        setLoading1(true);
        api.post(`${apiPath}/head-office-address`, {
            object_number: null,
            floor: null,
            apartment_number: null,
            town_name: null,
            zip_code: null,
            id_municipality: null,
            municipality_name: null,
            country_name: null,
            country_id: updateCountryId ?? null,
            note: null,
            ...address,
            id_town: idTownElement ? address?.id_town : null,
            town_display_name: idTownElement ? null : address?.town_name,
            town_name: idTownElement ? null : address?.town_name,
            country_name: null,
        })
            .then((response) => {
                setAddress(response ?? {});
                toast.success(response?.message ? response?.message : t("global-message-successfully_changed"));
                handleUser();
                setLoading1(false);
            })
            .catch((error) => {
                setLoading1(false);
                toast.error(printError(error) ? printError(error) : t("global-message-unknown_error"));
            });
        if (authCtx.isLoggedIn) {
            api.get("/profile/user-data").then((response) => {
                if (response) {
                    authCtx.refreshUser(response);
                }
            });
        }
    };

    useEffect(() => {
        const getTownById = async () => {
            const data = await api
                .get(`/profile/company/head-office-address/ddl/id_town?id_country=${address?.id_country}`)
                .then((response) => {
                    return response;
                })
                .catch((error) => {});

            const idTownElementIndex = rightForm.findIndex((item) => item.field === "id_town");
            if (idTownElementIndex === -1) return;
            const updatedForm = [...rightForm];

            if (data?.length > 1) {
                updatedForm[idTownElementIndex] = {
                    ...updatedForm[idTownElementIndex],
                    options: data,
                    type: "select",
                    columns: 12,
                    field: "id_town",
                };
            } else if (data?.length === 1) {
                updatedForm[idTownElementIndex] = {
                    ...updatedForm[idTownElementIndex],
                    type: "text",
                    options: {},
                    columns: 6,
                    field: "town_name",
                };

                const zipCodeExists = updatedForm.some((item) => item.field === "zip_code");
                if (!zipCodeExists) {
                    const zipCodeField = {
                        field: "zip_code",
                        label: "company_profile-seat-form-field-postal_code-label",
                        placeholder: "",
                        type: "text",
                        rows: false,
                        required: true,
                        disabled: false,
                        columns: 6,
                    };

                    updatedForm.splice(idTownElementIndex + 1, 0, zipCodeField);
                }
            }

            setAddressFormField(updatedForm);
            setUpdateFormFields((prev) => prev + 1);
        };

        if (address?.id_country) getTownById();
    }, [address?.id_country]);

    const handlerUpdatedAddress = (getUpdatedField) => {
        const updatedField = getUpdatedField();

        if (updatedField.id_country) {
            setAddress({ ...address, ...updatedField, zip_code: null, town_name: null, id_town: null });
        } else {
            setAddress({ ...address, ...updatedField });
        }
    };

    return (
        <ProfilePage>
            <h4 className={scss.title}>{t("company_profile-default-title")}</h4>

            {config && config?.active !== "1" && <Empty message={t("global-module_locked-title")} />}

            {config?.active === "1" && (company || address) && (
                <div className={scss.formsContainer}>
                    {company && (
                        <CreateForm
                            loading={loading}
                            title={t("company_profile-company-title")}
                            data={company}
                            setData={setCompany}
                            formFields={leftForm}
                            submit={{ label: "company_profile-company-form-button-submit", action: submitHandlerCompany }}
                            className={scss.form}
                            formButtons={config?.user_can_save_company_profile_data === "1" ? true : false}
                        />
                    )}
                    {address && (
                        <CreateForm
                            updateCountryId={updateCountryId}
                            setUpdateCountryId={setUpdateCountryId}
                            title={t("company_profile-seat-title")}
                            loading={loading1}
                            data={address}
                            setData={handlerUpdatedAddress}
                            formFields={addressFormField}
                            updateFormFields={updateFormFields}
                            submit={{ label: "company_profile-seat-form-button-submit", action: submitHandlerAddress }}
                            className={scss.form}
                            formButtons={config?.user_can_save_company_address_data === "1" ? true : false}
                        />
                    )}
                </div>
            )}
        </ProfilePage>
    );
};

export default CompanyProfilePage;
